
type IProps = {
    title?: string;
    subTitle?: string;
    size?: "2xl" | "xl" | "md" | "sm" | "xs"
}

const sizeConfig = {
    "2xl": {
        title: "text-4xl font-bold",
        subtitle: "text-base text-gray-600"
    },
    xl: {
        title: "text-2xl font-bold",
        subtitle: "text-base text-gray-600"
    },
    md: {
        title: "text-xl font-bold",
        subtitle: "text-sm text-gray-600"
    },
    sm: {
        title: "text-lg font-semibold",
        subtitle: "text-sm text-gray-600"
    },
    xs: {
        title: "text-md font-semibold",
        subtitle: "text-xs text-gray-600"
    }
}

export default function EHeader({ title, subTitle, size = "md" }: IProps) {
    const styles = sizeConfig[size];

    return (
        <div className="leading-tight">
            <div className={styles.title}>{title}</div>
            {subTitle && <div className={styles.subtitle}>{subTitle}</div>}
        </div>
    )
}